import React from "react";
import SEO from "../../../components/SEO";
import { Mail, Award } from "lucide-react";
import EktaImg from "../../../assets/Ekta.jpg";
import Testimonials from "../../../components/Testimonials";

const Ekta = () => {
  const facts = [
    {
      title: "Études",
      backText: "Ekta est médaillée d'or universitaire titulaire d'une maîtrise en technologie en informatique et d'un MBA en ressources humaines. Elle a élargi son expertise en complétant le programme de développeur cloud .NET full stack au Humber College. Elle a également complété une formation professionnelle en tests manuels et automatisés dans un institut renommé. En tant que Scrum Master certifiée, elle allie de solides compétences techniques à un leadership agile et à une gestion de projet collaborative pour offrir des solutions efficaces et innovantes.",
    },
    {
      title: "Carrière",
      backText: "Après avoir terminé sa maîtrise, Ekta a débuté sa carrière comme chargée de cours en informatique dans un collège gouvernemental en Inde. Passionnée par la programmation et la technologie, elle a ensuite fait la transition vers le secteur informatique et a travaillé comme ingénieure logicielle dans plusieurs organisations en Inde et au Canada. Au fil du temps, elle a développé un fort intérêt pour aider et éduquer les gens sur l'assurance au Canada, ce qui l'a inspirée à poursuivre une carrière de courtière d'assurance.",
    },
    {
      title: "Réalisations",
      backText: "Ekta a démontré l'excellence depuis ses premières années académiques, remportant de nombreux prix au niveau scolaire et participant activement à des débats, des arts, des programmes culturels et une exposition scientifique au niveau provincial. Elle a reçu la prestigieuse bourse du Premier Ministre pendant son baccalauréat et a ensuite obtenu le premier rang au niveau universitaire dans ses études de deuxième cycle. En tant que professeure, elle a été très appréciée pour ses contributions au comité d'admission du collège et pour avoir animé avec assurance des événements académiques et culturels. En reconnaissance de ses réalisations et du respect de la communauté, elle a été invitée comme invitée d'honneur principale dans sa ville natale pour effectuer la cérémonie de levée du drapeau lors des journées nationales.",
    },
    {
      title: "Loisirs",
      icon: <Award size={36} />,
      backText: "Ekta apprécie la prise de parole en public, l'animation sur scène et la participation à des activités culturelles et créatives. Ses intérêts comprennent le débat, la récitation de poésie, la peinture, l'art du henné, le chant et la danse. Elle a également une passion pour l'apprentissage, l'enseignement et la participation à des activités communautaires qui inspirent et éduquent les autres.",
    },
  ];

  return (
    <>
      <SEO
        title="Ekta — Courtière d'assurance agréée | einsured.ca"
        description="Découvrez Ekta, courtière chez einsured.ca, qui aide les Canadiens à choisir une assurance adaptée grâce à des conseils d’experts."
        keywords="Ekta courtière d'assurance, conseillère en assurance Canada, meilleur courtier d'assurance, expert en assurance vie"
        ogType="profile"
      />
      <section className="min-h-screen flex flex-col justify-center items-center px-6 sm:px-12 md:px-24 py-16" style={{ backgroundColor: "#f5f9ff" }} >
      <style>{`
        .flip-card {
          background-color: transparent;
          perspective: 1000px;
        }
        .flip-card-inner {
          position: relative;
          width: 100%;
          height: 350px;
          text-align: center;
          transition: transform 0.8s;
          transform-style: preserve-3d;
          border-radius: 24px;
          box-shadow: 0 15px 25px rgba(0, 0, 0, 0.15);
        }
        .flip-card:hover .flip-card-inner {
          transform: rotateY(180deg);
        }
        .flip-card-front,
        .flip-card-back {
          position: absolute;
          width: 100%;
          height: 100%;
          border-radius: 24px;
          -webkit-backface-visibility: hidden;
          backface-visibility: hidden;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          font-family: "Inter", sans-serif;
          font-weight: 600;
        }
        .flip-card-front {
          background: linear-gradient(to bottom, #12a5dd, #3b4f80);
          color: white;
        }
        .flip-card-back {
          background: linear-gradient(to bottom, #3b4f80, #12a5dd);
          transform: rotateY(180deg);
          color: white;
          padding: 0 1.5rem;
        }

        /* Mobile polish for flip cards */
        @media (max-width: 640px) {
          .flip-card-inner {
            height: auto;
            min-height: 260px;
            transform: none !important;
          }
          .flip-card-front {
            display: none;
          }
          .flip-card-back {
            transform: none;
            padding: 1.25rem 1.25rem;
          }
        }
      `}</style>

      {/* TOP SECTION */}
      <div className="max-w-6xl w-full grid md:grid-cols-2 gap-12 items-start">
        {/* LEFT SIDE */}
        <div className="flex flex-col items-center md:items-start w-full">
          {/* Blue Box */}
          <div className="w-full rounded-t-[32px] px-8 py-6 text-center md:text-left shadow-md" style={{ backgroundColor: "#12a5dd", color: "white" }}>
            <h1 className="text-3xl sm:text-4xl font-bold mb-2">Ekta</h1>
            <p className="text-lg font-semibold">Courtière d'assurance</p>
          </div>
          {/* Bottom Blue Box */}
          <div className="w-full rounded-b-[32px] px-8 py-8 shadow-lg" style={{ backgroundColor: "#12a5dd", color: "white" }}>
            <p className="text-sm sm:text-base leading-relaxed mb-10 text-center md:text-left">Ekta est médaillée d'or universitaire titulaire d'une maîtrise en technologie en informatique et d'un MBA en ressources humaines. Passionnée par l'aide et l'éducation des gens, Ekta a maintenant entrepris son parcours dans le secteur de l'assurance au Canada. En tant que courtière d'assurance, elle se consacre à aider les particuliers et les familles à prendre des décisions éclairées concernant leur protection financière et leur sécurité future.</p>

            {/* CONTACT */}
            <div className="grid grid-cols-1 sm:grid-cols-[2fr_3fr] gap-x-4 gap-y-6">
              <a href="tel:+14162575700" className="bg-white text-[#3b5180] font-medium text-base px-5 py-3 rounded-full shadow-md text-center" >(416) 257-5700</a>
              <a href="mailto:insurewithekta@gmail.com" className="bg-white text-[#3b5180] font-medium text-base px-5 py-3 rounded-full shadow-md flex items-center justify-center gap-2 break-all sm:break-normal"><Mail className="w-4 h-4" />insurewithekta@gmail.com</a>
            </div>
          </div>

          {/* Call Now */}
          <div className="text-center md:text-left mt-10 md:mt-12 w-full">
            <a href="https://book.einsured.ca/widget/bookings/ekta-einsured" className="bg-[#3b4f80] hover:bg-[#2f3d66] text-white font-semibold px-10 py-3 rounded-full shadow-md transition w-full sm:w-auto inline-block text-center">Prendre rendez-vous</a>
            <p className="text-sm mt-6">Consultations gratuites de 15 à 30 minutes.</p>
          </div>
        </div>

        {/* RIGHT IMAGE */}
        <div className="flex justify-center md:justify-end mt-8 md:mt-0">
          <img src={EktaImg} alt="Ekta" className="rounded-[32px] shadow-md w-full max-w-xs sm:max-w-sm h-[420px] object-cover object-top" />
        </div>
      </div>

      {/* FACTS */}
      <div className="mt-24 max-w-6xl w-full">
        <div className="text-center mb-12 px-2">
          <h2 className="text-3xl sm:text-5xl font-bold text-[#49628b] mb-4">Quelques faits sur Ekta</h2>
          <p className=" text-base sm:text-lg">Découvrez le profil d'Ekta pour mieux connaître ses domaines d'expertise et ses intérêts personnels.</p>
        </div>

        {/* Flip Cards Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-10 max-w-5xl mx-auto">
          {facts.map((fact) => (
            <div key={fact.title} className="flip-card">
              <div className="flip-card-inner">
              {/* FRONT */}
                <div className="flip-card-front px-4">
                  {fact.icon && (
                    <div className="mb-3 flex justify-center">{fact.icon}</div>
                  )}
                  <h3 className="text-white text-2xl font-bold">{fact.title}</h3>
                </div>
                {/* BACK */}
                <div className="flip-card-back flex px-4">
                  <p className="text-white text-sm sm:text-base leading-relaxed font-normal">{fact.backText}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
    {/* 4 EASY STEPS */}
    <section className="w-full flex justify-center bg-white py-16 sm:py-24 px-6 sm:px-12 md:px-24">
      <div className="max-w-6xl w-full grid md:grid-cols-2 gap-16 items-center">
        {/* LEFT SIDE TEXT */}
        <div className="flex flex-col items-center md:items-start text-center md:text-left">
          <h2 className="text-3xl sm:text-5xl font-bold text-[#49628b] mb-5">4 étapes simples</h2>
          <p className="text-base sm:text-lg text-[#5f6f8f] mb-10 max-w-lg">Obtenez votre protection en quelques minutes et profitez d'une couverture d'assurance vie parfaitement adaptée à vos besoins.</p>
          <a href="tel:+14162575700" className="bg-[#3b4f80] hover:bg-[#2f3d66] text-white font-semibold px-12 py-3.5 rounded-full shadow-lg transition w-full sm:w-auto text-center">Appelez maintenant !</a>
          <p className="text-sm mt-4">Consultations gratuites de 15 à 30 minutes.</p>
        </div>
        {/* RIGHT SIDE */}
        <div className="bg-[#f5f8ff] rounded-[32px] shadow-lg px-6 sm:px-10 py-8 sm:py-10 md:px-14 md:py-12">
          <div className="relative pl-2 sm:pl-4">
            <div className="absolute left-6 sm:left-8 top-6 bottom-6 w-[2px] bg-[#3b4f80]/25"></div>
              {/* Step 1 */}
              <div className="flex items-start gap-4 sm:gap-6 mb-8 sm:mb-10 relative z-10">
                <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-[#12a5dd] text-white rounded-full font-semibold text-lg sm:text-xl shrink-0">1</div>
                <div>
                  <h3 className="text-[#49628b] font-bold text-base sm:text-lg mb-1">Informations de base</h3>
                  <p className="text-[#5f6f8f] text-sm md:text-base leading-relaxed">Répondez à quelques questions de base pour nous aider à mieux vous connaître.</p>
                </div>
              </div>
              {/* Step 2 */}
              <div className="flex items-start gap-4 sm:gap-6 mb-8 sm:mb-10 relative z-10">
                <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-[#12a5dd] text-white rounded-full font-semibold text-lg sm:text-xl shrink-0">2</div>
                <div>
                  <h3 className="text-[#49628b] font-bold text-base sm:text-lg mb-1">Analyse des besoins</h3>
                  <p className="text-[#5f6f8f] text-sm md:text-base leading-relaxed">Déterminez la couverture appropriée pour protéger vos proches.</p>
                </div>
              </div>

              {/* Step 3 */}
              <div className="flex items-start gap-4 sm:gap-6 mb-8 sm:mb-10 relative z-10">
                <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-[#12a5dd] text-white rounded-full font-semibold text-lg sm:text-xl shrink-0">3</div>
                <div>
                  <h3 className="text-[#49628b] font-bold text-base sm:text-lg mb-1">Questions de santé</h3>
                  <p className="text-[#5f6f8f] text-sm md:text-base leading-relaxed">Répondez à quelques questions liées à la santé pour obtenir un produit adapté à vos besoins.</p>
                </div>
              </div>
              {/* Step 4 */}
              <div className="flex items-start gap-4 sm:gap-6 relative z-10">
                <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-[#12a5dd] text-white rounded-full font-semibold text-lg sm:text-xl shrink-0">4</div>
                <div>
                  <h3 className="text-[#49628b] font-bold text-base sm:text-lg mb-1">Obtenez votre devis gratuit !</h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Ekta;
